(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });

  document.addEventListener('click', function (event) {
    const facetsDrawer = event.target.closest('.facets--drawer');
    if (!facetsDrawer || !facetsDrawer.hasAttribute('open')) {
      return;
    }

    const clickedSummary = event.target.closest('.facets__item summary');
    if (!clickedSummary) {
      return;
    }

    const clickedDetails = clickedSummary.closest('details');
    if (!clickedDetails) {
      return;
    }

    if (!clickedDetails.hasAttribute('open')) {
      const otherOpenAccordions = facetsDrawer.querySelectorAll(
        '.facets__item details[open]'
      );
      
      otherOpenAccordions.forEach((accordion) => {
        if (accordion.id !== clickedDetails.id) {
          accordion.removeAttribute('open');
        }
      });
    }
  });
})();
